import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  currentKpi: any;
  kpiList: any[];
  isKpiDrawerOpen: boolean;
  isBadEventDrawerOpen: boolean;
  kpiMetaConfigs: any;
};

type Action = {
  setCurrentKpi: (currentKpi: State['currentKpi']) => void;
  setKPIs: (kpiList: State['kpiList']) => void;
  setIsKpiDrawerOpen: (isKpiDrawerOpen: State['isKpiDrawerOpen']) => void;
  setIsBadEventDrawerOpen: (isBadEventDrawerOpen: State['isBadEventDrawerOpen']) => void;
  setKpiMetaConfigs: (kpiMetaConfigs: State['kpiMetaConfigs']) => void;
};

const initialState: State = {
  currentKpi: {},
  kpiList: [],
  isKpiDrawerOpen: false,
  isBadEventDrawerOpen: false,
  kpiMetaConfigs: {},
};

const kpiStore = create(
  devtools(
    (set: any, get: any) => ({
      ...initialState,
      setCurrentKpi: (currentKpi) => set(() => ({ currentKpi })),
      setKPIs: (kpiList) => set(() => ({ kpiList })),
      setIsKpiDrawerOpen: (isKpiDrawerOpen) => set(() => ({ isKpiDrawerOpen })),
      setIsBadEventDrawerOpen: (isBadEventDrawerOpen) => set(() => ({ isBadEventDrawerOpen })),
      setKpiMetaConfigs: (kpiMetaConfigs) => set(() => ({ kpiMetaConfigs })),
    }),
    { name: 'kpiStore' },
  ),
);

export default kpiStore;
